import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import ProfilePersonalInformation from './ProfilePersonalInformation.js';
import { actions } from './ProfilePersonalInformation.actions';
import { getContactTypes, getTimezonesList } from './ProfilePersonalInformation.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    contactTypes: getContactTypes,
    timezonesList: getTimezonesList,
});

const ProfilePersonalInformationComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            nickname: state.user.publisher.nickname,
            id: state.user.publisher.id,
            anonymous: state.user.publisher.anonymous,
            subscribed: state.user.publisher.subscribed,
            contacts: state.user.publisher.contacts,
            name: state.user.publisher.name,
            surname: state.user.publisher.surname,
            rank: state.user.publisher.rank,
            email: state.user.email,
            timezone: state.user.timezone,
            ranks: state.publisherRanks
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            settingsSave: actions.settingsSave
        };
    }
)(ProfilePersonalInformation);

export default ProfilePersonalInformationComponent;
